import { GeocoderResult } from '~/src/common/services/Google/types';
import { DeliveryAddress } from '~/src/common/typings/cart';

const getComponentName = (
  addressComponents: GeocoderResult['address_components'],
  type: string,
) => {
  const res = addressComponents?.find(c => c.types.includes(type));
  return { short: res?.short_name ?? '', long: res?.long_name ?? '' };
};

const mapGeocoderResultToDeliveryAddress = (result: GeocoderResult): DeliveryAddress => ({
  addressComponents: {
    streetNumber: getComponentName(result.address_components, 'street_number').long,
    street: getComponentName(result.address_components, 'route').long,
    city: getComponentName(result.address_components, 'locality').long,
    postalCode: getComponentName(result.address_components, 'postal_code').long,
    country: getComponentName(result.address_components, 'country').long,
    countryCode: getComponentName(result.address_components, 'country').short,
  },
  formattedAddress: result.formatted_address,
  location: {
    lat: result.geometry.location.lat(),
    lng: result.geometry.location.lng(),
  },
});

export default mapGeocoderResultToDeliveryAddress;
